/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Pain_Heading1Inputs */

const ja_playdata_eventreport_pain_heading1 = /** @type {(inputs: Playdata_Eventreport_Pain_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント主催者、スポンサー企業、eスポーツチームの皆様`)
};

const en_playdata_eventreport_pain_heading1 = /** @type {(inputs: Playdata_Eventreport_Pain_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For event organisers, sponsors and esports teams`)
};

/**
* | output |
* | --- |
* | "For event organisers, sponsors and esports teams" |
*
* @param {Playdata_Eventreport_Pain_Heading1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_pain_heading1 = /** @type {((inputs?: Playdata_Eventreport_Pain_Heading1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Pain_Heading1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_pain_heading1(inputs)
	return en_playdata_eventreport_pain_heading1(inputs)
});
export { playdata_eventreport_pain_heading1 as "playdata_eventReport_pain_heading" }